import React, { Fragment } from 'react';

import RecordIcon from '@material-ui/icons/FiberManualRecord';
import IconButton from '@material-ui/core/IconButton';
import { useAppState } from '../../../state';
import { MESSAGE_TYPES } from '../../../constants';
import useSendMessage from '../../../hooks/useSendMessage/useSendMessage';


//ChatDialog
//import useFullScreenToggle from '../../../hooks/useFullScreenToggle/useFullScreenToggle';

export default function RecordButton() {
    const { isRoomRecording, setIsRoomRecording, initRemoteAction } = useAppState();
    const [sendMessage] = useSendMessage();

    const setText = () => {
        return isRoomRecording ? "Stop Recording" : "Record";
    }; 

    //initRemoteAction
    const toggleRecord = () => {
        var strAction = MESSAGE_TYPES.RECORDING_STARTED;
        if (isRoomRecording) {
            strAction = MESSAGE_TYPES.RECORDING_STOPPED;
        }
        sendMessage(strAction, "");
        initRemoteAction(strAction, "", "").then((response) => {
                var t = JSON.parse(response);
                if (isRoomRecording) {
                    setIsRoomRecording(t.msg === "" ? false : true);
                } else {
                    setIsRoomRecording(t.msg === "" ? true : false);
                }
        });
    };

    return (
        <Fragment>
            <IconButton color="inherit" onClick={() => { toggleRecord() }}>
                <RecordIcon /> <div className="text-center">
                    {setText()}
                </div>
            </IconButton>
        </Fragment>
    );
}
